const isLocal = (typeof window !== 'undefined' && (
    ['localhost', '127.0.0.1', '0.0.0.0', '::1'].includes(window.location.hostname) ||
    window.location.hostname.startsWith('192.168.') ||
    window.location.hostname.startsWith('10.') ||
    window.location.hostname.startsWith('172.') ||
    window.location.hostname.endsWith('.local') ||
    !window.location.hostname.includes('.') ||
    ['8080', '8081', '3000', '5173', '15068', '15069'].includes(window.location.port)
)) || (typeof process !== 'undefined' && process.env && (process.env.NODE_ENV === 'development' || process.env.VITE_USER_NODE_ENV === 'development'))

if (isLocal) {
    console.log('[BaseServerUrl] Detected Local Environment:', {
        hostname: typeof window !== 'undefined' ? window.location.hostname : 'n/a',
        port: typeof window !== 'undefined' ? window.location.port : 'n/a'
    });
}

const serverUrl = isLocal ? 'http://localhost:15068' : 'https://server.4yshop.top'
// const serverUrl = isLocal ? 'http://192.168.1.8:15068' : 'https://server.4yshop.top'

// const serverUrl = 'http://10.100.51.119:15068'

const assetsUrl = isLocal ? 'http://localhost:15068/assets' : 'https://assets.4yshop.top/assets'
// const assetsUrl = isLocal ? 'http://192.168.1.8:15068/assets' : 'https://assets.4yshop.top/assets'

const avatarUrl = isLocal ? 'http://localhost:15068/assets' : 'https://server.4yshop.top/assets'
// const avatarUrl = isLocal ? 'http://192.168.1.8:15068/assets' : 'https://server.4yshop.top/assets'

const BaseServerUrl = serverUrl
export { assetsUrl, avatarUrl, BaseServerUrl }
export default serverUrl
